import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type AvnetAbacusV3LocaleCurrencyDTO = z.infer<typeof AvnetAbacusV3LocaleCurrencyDTORuntype>;
export const AvnetAbacusV3LocaleCurrencyDTORuntype = z.enum(['Eur', 'Usd', 'Gbp', 'Jpy']);

export interface AvnetAbacusV3CredentialsDTO extends z.infer<typeof AvnetAbacusV3CredentialsDTORuntype> {}
export const AvnetAbacusV3CredentialsDTORuntype = z.object({
    client_id: z.string(),
    client_secret: z.string(),
    subscription_key: z.string(),
    currency: AvnetAbacusV3LocaleCurrencyDTORuntype.nullable(),
});

export interface AvnetAbacusV3CredentialsInputDTO extends z.infer<typeof AvnetAbacusV3CredentialsInputDTORuntype> {}
export const AvnetAbacusV3CredentialsInputDTORuntype = z.object({
    client_id: z.string().optional(),
    client_secret: z.string().optional(),
    subscription_key: z.string().optional(),
    currency: AvnetAbacusV3LocaleCurrencyDTORuntype.nullable(),
});

export interface AvnetAbacusV3ResponseBodyDTO extends z.infer<typeof AvnetAbacusV3ResponseBodyDTORuntype> {}
export const AvnetAbacusV3ResponseBodyDTORuntype = z.object({
    data: AvnetAbacusV3CredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
